import React, { SyntheticEvent, useEffect, useState } from 'react';
import filtersStyles from '../../Filters.module.scss';
import { Action, CloseLight } from 'esa-ui-library';
import { PropertyType, useStore } from '../../../../../common';
import { FilterDropdown } from '../FilterDropdown/FilterDropdown';
import { cloneDeep, find } from 'lodash';
import { getActiveLabels, getFilterValue, getUpdateOptions, selectPreselectedOptions } from '../../Filters.helper';
import useFilters from '../../../../../common/hooks/useFilters';

const PermissionsFilter = (): JSX.Element => {
	const [{ permissions, filters }] = useStore();
	const [filterOptions, setFiltersOptions] = useState<PropertyType[]>([]);
	const { onFilter } = useFilters();

	const onFilterChange = (option: PropertyType) => {
		const updateOptions = getUpdateOptions(option, filterOptions);
		const filterValue = getFilterValue(updateOptions);

		onFilter([{ name: 'permissions', value: filterValue }]);
	};

	const onFilterRemove = (e: SyntheticEvent) => {
		e.stopPropagation();

		onFilter([{ name: 'permissions', value: '' }]);
	};

	const getLabelContent = () => {
		const activeLabels = getActiveLabels(filterOptions);
		if (!activeLabels.length) return 'All';

		return (
			<>
				{activeLabels[0]}
				{activeLabels.length > 1 ? `+${activeLabels.length - 1}` : ''}
				<i className={filtersStyles.ClearFilter} onClick={onFilterRemove}>
					<CloseLight size={16} />
				</i>
			</>
		);
	};

	useEffect(() => {
		if (permissions) {
			setFiltersOptions(cloneDeep(permissions));
		}
	}, [permissions]);

	useEffect(() => {
		const filter = find(filters, ['name', 'permissions'])?.value || '';
		setFiltersOptions(selectPreselectedOptions(permissions, filter));
	}, [filters]);

	return (
		<Action
			label='Permissions'
			labelContent={getLabelContent()}
			select
			className={`${filtersStyles.Filter} 
			${getActiveLabels(filterOptions).length ? filtersStyles.Active : ''} `}
			dataId='permissions-filter'
		>
			<FilterDropdown data={filterOptions} onChange={onFilterChange} isSearchable />
		</Action>
	);
};

export { PermissionsFilter };
